import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "embedding-shell" }
const _hoisted_2 = { class: "embedding-header" }
const _hoisted_3 = { class: "embedding-header-main" }
const _hoisted_4 = { class: "embedding-provider-avatar" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "embedding-title-wrap" }
const _hoisted_8 = { class: "embedding-title-row" }
const _hoisted_9 = { class: "embedding-title" }
const _hoisted_10 = { class: "embedding-subtitle" }
const _hoisted_11 = { class: "embedding-header-actions" }
const _hoisted_12 = { class: "embedding-spec-grid" }
const _hoisted_13 = { class: "embedding-spec" }
const _hoisted_14 = { class: "embedding-spec-v embedding-spec-v-mono" }
const _hoisted_15 = { class: "embedding-spec" }
const _hoisted_16 = { class: "embedding-spec-v" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "embedding-desktop-card",
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.emitEdit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: (_ctx.icon as ProviderIcon).src,
                    alt: `${_ctx.config.providerKey || 'embedding'} icon`,
                    class: "embedding-provider-avatar-image",
                    onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                  }, null, 40, _hoisted_5))
                : (_ctx.showStandaloneIcon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "embedding-provider-avatar-mask",
                      style: _normalizeStyle(_ctx.iconMaskStyle),
                      role: "img",
                      "aria-label": `${_ctx.config.providerKey || 'embedding'} icon`
                    }, null, 12, _hoisted_6))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "embedding-provider-avatar-fallback",
                      style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                    }, _toDisplayString(_ctx.providerInitials), 5))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.config.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.config.providerKey || 'No provider'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_tooltip, {
              text: "Edit Embedding Model",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  icon: "mdi-pencil-outline",
                  size: "small",
                  variant: "plain",
                  class: "embedding-edit-icon",
                  onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                }), null, 16, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "embedding-spec-k" }, "Model", -1)),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.modelChipLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "embedding-spec-k" }, "Usage", -1)),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.collectionUsageLabel), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}